<template>
  <v-container fluid>
    <div>
      <div class="error" v-if="error">
        <p>{{ error }}</p>
      </div>

      <SelectPostType @type-selected="handlePostTypeSelected" />

      <div v-if="(this.$store.getters.user.role === 'a' || this.$store.getters.user.role === 'n') && parentsInfo.length"
        style="margin: 16px 0; padding: 10px 16px; background: #f0fafb; border-left: 3px solid #00A9B3; text-align: left;">
        <p style="color: #00A9B3; margin: 0 0 6px 0; font-weight: 500;">
          {{ $t("general.post.addressedTo") }}
        </p>
        <template>
          <div v-for="parent in parentsInfo" :key="parent.id" style="color: #8e8e8e; margin-bottom: 2px;">
            <strong  style="color: #4a4a4a;">{{ parent.name }}</strong><span v-if="parent.role"> ({{ parent.role }})</span>
            <span v-if="parent.translationLanguage">— {{ $t("general.post.translationLanguage") }}: {{ parent.translationLanguage }}</span>
          </div>
        </template>
      </div>
      <div v-if="(this.$store.getters.user.role === 'a' || this.$store.getters.user.role === 'n') && !hasTranslationLanguages">
           <div style="width: 90%; margin: 16px auto; border: #000000; border-style: solid; border-width: thin; padding: 10px">
            <p style="color: #00A9B3; margin: 0 0 0 16px">
              {{ $t(`general.addressingLanguages`) }}
              <span style="color: #8e8e8e" class="d-flex" v-for="lang in languages" :key="lang">{{ $t(`general.languages.${lang}`) }}</span>
            </p>
           </div>retr
      </div>
      <Milestone v-if="milestone" :milestone="milestone" :date="Date.now()" :image="uploadId ? uploadId : null"
        :file="file" />

      <div class="form" v-if="!milestone">
        <InputField :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }" :inputStyles="{ border: 0, margin: 0 }"
          :labelTitle="$t('general.post.form-title')" :placeholder="$t('general.post.form-title-placeholder')"
          v-model="title" style="margin-bottom: 16px; margin-top: 16px" @input="typingTimer(title)" ref="title" />
        <TextAreaField :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }" :inputStyles="{ border: 0, margin: 0 }"
          class="input" v-model="content" :labelTitle="$t('general.post.form-post')"
          :placeholder="$t('general.post.form-post-placeholder')" rows="2" style="margin-bottom: 16px"
          @input="typingTimer(content)" />
      </div>
      <div v-else>
        <div class="form">
          <TextAreaField @change.native="
            $store.commit('editingPost', { title, content, access: postAccess, postId })
            " :labelStyles="{ color: '#00A9B3', margin: '0 0 0 16px' }" :inputStyles="{ border: 0, margin: 0 }"
            class="input" v-model="content" :labelTitle="$t('general.post.form-post')"
            :placeholder="$t('general.milestone.form-post-placeholder')" rows="2" style="margin: 16px"
            @input="typingTimer(content)" />
        </div>
      </div>

      <div class="d-flex flex-wrap mb-6 justify-start align-stretch">
        <div class="col-12 col-md-6 col-lg-4 col-xl-3 d-flex flex-column justify-start align-center" :key="'image' + i"
          v-for="(fileObject, i) in files">
          <Button class="close" @click.native="deleteFile(i)" margin="10px" color="#31b9be" bgcolor="#fff" width="30px"
            padding="0" icon="close-blue"></Button>

          <div style="width: 100%; height: 100%;">
            <video v-if="fileObject.isVideo" class="upload-preview-video" controls preload="metadata" playsinline>
              <source :src="fileObject.src" :type="fileObject.file.type" />
              <track kind="captions" srclang="en" label="Captions unavailable"
                src="data:text/vtt;charset=utf-8,WEBVTT" />
            </video>
            <v-img v-else width="100%" height="100%" contain :id="'img-preview-' + i" :src="fileObject.src"
              :alt="$t('general.post.upload-alt')" />
          </div>
        </div>
      </div>

      <video v-if="post && post.upload && isVideoUpload(post.upload.mimeType)" id="img-preview"
        class="upload-preview-video" controls preload="metadata" playsinline>
        <source :src="post.upload.blobUri" :type="post.upload.mimeType" />
        <track kind="captions" srclang="en" label="Captions unavailable" src="data:text/vtt;charset=utf-8,WEBVTT" />
      </video>

      <auto-rotate v-else-if="post && post.upload">
        <img id="img-preview" :src="post.upload.blobUri" :alt="'Foto van post ' + title + '.'" />
      </auto-rotate>

      <div v-if="editId && post && post.upload" class="d-flex justify-center">
        <Button @click.native="removeCurrentImage" :title="$t('general.post.remove-upload')" color="#e05484"
          bgcolor="#fff" style="border: 2px solid #e05484; margin: 8px 0 0 0" />
      </div>

      <div class="space"></div>

      <DictionarySelector v-if="addDictionary" :entries="dictionaryEntries"
        @selection-changed="dictionarySelectionChanged" />

      <AddedDictionaryEntries :entries="addedDictionaryEntries" v-if="addDictionary" @entry-deleted="
        id =>
        (addedDictionaryEntries = addedDictionaryEntries.filter(
          e => e.id !== id
        ))
      " />

      <br />

      <ListItem icon="eye-blue.svg" @click.native="$modal.show('access-menu-modal')">
        {{ $t("general.post.form-visibility") }}:
        <span class="pink--text">{{ visibilitySummary }}</span>
      </ListItem>

      <ListItem v-if="!postId && $store.getters.user.role === 'p' && $store.getters.user.patients.length > 1"
        icon="eye-blue.svg" @click.native="$modal.show('patients-menu-modal')">
        {{ $t("general.post.form-patients") }}:
        <span class="pink--text">{{
          patients === "all"
            ? $t("general.post.patients-all")
            : $t("general.post.patients-current", { firstName: $store.getters.patient.firstName })
        }}</span>
      </ListItem>

      <ListItem v-if="!milestone" icon="flag-blue.svg" @click.native="$modal.show(`milestone-modal`)">
        {{ $t("general.milestone.title") }}
      </ListItem>
      <ListItem v-else highlighted="true" icon="flag-pink.svg" @click.native="milestone = null">
        {{ $t("general.milestone.title") }}
      </ListItem>

      <ListItem icon="camera-blue.svg">
        <Upload @fileSelect="fileSelect" :label="$t('general.post.upload')" accept="image/*,video/*" />
      </ListItem>

      <LoadingButton v-if="loading" style="margin: 16px 0"></LoadingButton>

      <div v-else class="d-flex flex-wrap justify-center align-center mb-10">
        <div class="col-12 center text-center justify-center align-center align-content-center"
          v-if="draftPossible && this.$store.getters.user.role !== 'p'">
          <div class="mt-2">
            <label for="isDraft" class="checkbox-container" style="display: inline">
              {{ $t('general.post.draft') }}
              <input style="background-color: #e05484; accent-color: #e05484" type="checkbox" id="isDraft"
                v-model="isDraft" />
              <span class="checkmark" style="border-color: #e05484"></span>
            </label>
          </div>
        </div>

        <div v-if="!editId && this.files.length > 0">
          <Button @click.native="createPosts('add')" :title="$t('general.post.action-post')" style="margin: 16px 0; " />
        </div>
        <div v-else-if="!editId">
          <Button @click.native="writePost('add')" :title="$t('general.post.action-save')" style="margin: 16px 0" />
        </div>
        <div v-else>
          <Button @click.native="writePost('edit')" :title="$t('general.post.action-save')" style="margin: 16px 0" />
        </div>
      </div>

      <modal class="menu" :name="'access-menu-modal'" width="100%" height="auto">
        <div style="padding: 16px;">
          <p style="color: #00A9B3; margin: 0 0 12px 0; font-weight: 500;">
            {{ $t('general.post.visibility-title') }}
          </p>
          <label v-if="$store.getters.user.role !== 'n' && $store.getters.user.role !== 'a'"
            style="display: block; margin-bottom: 8px;">
            <input type="checkbox" v-model="isVisibleToSelf" disabled />
            <span style="margin-left: 8px;">{{ $t('general.post.visibility-self') }}</span>
          </label>
          <label style="display: block; margin-bottom: 8px;">
            <input type="checkbox" v-model="isVisibleToParents" />
            <span style="margin-left: 8px;">{{ $t('general.post.visibility-parents') }}</span>
          </label>
          <label style="display: block; margin-bottom: 8px;">
            <input type="checkbox" v-model="isVisibleToHospital"
              :disabled="$store.getters.user.role === 'n' || $store.getters.user.role === 'a'" />
            <span style="margin-left: 8px;">{{ $t('general.post.visibility-hospital') }}</span>
          </label>
          <label style="display: block;">
            <input type="checkbox" v-model="isVisibleToThirdParties" />
            <span style="margin-left: 8px;">{{ $t('general.post.visibility-third-parties') }}</span>
          </label>

          <div style="display: flex; justify-content: flex-end; margin-top: 12px;">
            <Button @click.native="$modal.hide('access-menu-modal')" :title="$t('general.post.action-close')"
              color="#e05484" bgcolor="#fff" style="border: 2px solid #e05484" />
          </div>
        </div>
      </modal>

      <modal class="menu" :name="'patients-menu-modal'" width="100%" height="auto">
        <ListItem :highlighted="patients === 'all' ? true : false" border="1px solid #31b9be" @click.native="
          patients = 'all';
        $modal.hide('patients-menu-modal');
        ">{{ $t("general.post.patients-all") }}</ListItem>
        <ListItem :highlighted="patients === 'current' ? true : false" border="1px solid #31b9be" last="true"
          @click.native="
            patients = 'current';
          $modal.hide('patients-menu-modal');
          ">{{ $t("general.post.patients-current", { firstName: this.$store.getters.patient.firstName }) }}</ListItem>
      </modal>
    </div>

    <MilestoneModal @select="milestone = $event" />
    <CreateMilestoneModal />
    <NeoparentCreateReflection />
  </v-container>
</template>

<script>
import { neoparentDictionaryEntries as dictionaryEntries, neoparentPosts, neoparentUploads, neoparentPatients } from "@/api";
import NeoparentCreateReflection from "@/components/NeoparentCreateReflection";
import SelectPostType from "@/components/SelectPostType";

const MAX_IMAGE_UPLOAD_BYTES = 50 * 1024 * 1024;
const MAX_VIDEO_UPLOAD_BYTES = 300 * 1024 * 1024;

export default {
  name: "neoparent-create-post",
  components: {
    NeoparentCreateReflection,
    SelectPostType
  },
  data() {
    return {
      title: this.$store.state.post.title,
      content: this.$store.state.post.content,
      isVisibleToSelf: true,
      isVisibleToParents: true,
      isVisibleToHospital: true,
      isVisibleToThirdParties: false,
      patients: "current",
      postId: this.$store.state.post.id,
      uploadId: this.$store.state.post.uploadId,
      milestone: null,
      isDraft: false,
      draftPossible: true, //possible if editId and was enabled. Not able to set draft on already fully posted post
      loading: false,
      error: "",
      file: null,
      files: [],
      dictionaryEntries: [],
      timer: null,
      addedDictionaryEntries:
        this.$store.state.post.addedDictionaryEntries || [],
      editId: new URL(window.location).searchParams.get("postId"),
      post: null,
      postType: "post",
      removeCurrentPostImage: false,
      currentEditPreviewObjectUrl: null,
      parents: [],
      languages: []
    };
  },
  mounted() {
    if (this.$store.getters.patient.languages) {
      this.languages = JSON.parse(this.$store.getters.patient.languages)
    }

    // Focus title input field
    this.$refs.title.$el.children[1].focus();

    this.fetchParents();

    if (this.$store.getters.user.role === "p" && !this.editId) {
      this.$modal.show('create-type-modal');
    }
    if (this.editId) {
      this.postId = this.editId
      neoparentPosts
        .getAllPostsForPatient(this.$store.getters.patient.id)
        .then(result => {
          this.post = result.data.posts.find(x => x.id == this.editId);
          console.log(this.post)
          this.addedDictionaryEntries = this.post.dictionaryEntries ? this.post.dictionaryEntries : []
          this.title = this.post.title;
          this.content = this.post.content;
          this.isDraft = this.post.isDraft
          this.draftPossible = this.post.isDraft
          this.applyAccessToForm(this.post.access);
          this.milestone = this.post.milestone ? this.post.milestone : null;
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  beforeDestroy() {
    this.files.forEach(fileObject => this.releasePreviewUrl(fileObject));
    this.clearCurrentEditPreviewUrl();
  },
  computed: {
    hasTranslationLanguages() {
      return this.parents.some(parent => parent.translationLanguage);
    },
    addDictionary() {
      return this.$store.getters.user.role === "a" || this.$store.getters.user.role === "n";
    },
    postAccess() {
      return this.buildAccess();
    },
    uploadAccess() {
      return this.isVisibleToThirdParties ? "pub" : "priv";
    },
    parentsInfo() {
      if (!this.parents || this.parents.length === 0) {
        return [];
      }

      return this.parents.map(parent => ({
        id: parent.id,
        name: `${parent.firstName || ""} ${parent.lastName || ""}`.trim(),
        role: "",
        translationLanguage: parent.translationLanguage
      }));
    },
    visibilitySummary() {
      const labels = [];

      if (this.$store.getters.user.role !== "n" && this.$store.getters.user.role !== "a") {
        labels.push(this.$t("general.post.visibility-self"));
      }
      if (this.isVisibleToParents) {
        labels.push(this.$t("general.post.visibility-parents"));
      }

      if (this.isVisibleToHospital) {
        labels.push(this.$t("general.post.visibility-hospital"));
      }

      if (this.isVisibleToThirdParties) {
        labels.push(this.$t("general.post.visibility-third-parties"));
      }

      return labels.join(", ");
    }
  },
  methods: {
    fetchParents() {
      if (this.$store.getters.user.role !== "a" && this.$store.getters.user.role !== "n") {
        return;
      }

      const patientId = this.$store.getters.patient?.id;
      if (!patientId) {
        return;
      }

      neoparentPatients
        .getPatientParents(patientId)
        .then(res => {
          this.parents = res?.data?.parents || [];
        })
        .catch(err => {
          this.consoleLog(err);
        });
    },
    isVideoUpload(mimeType) {
      return (mimeType || "").toLowerCase().startsWith("video/");
    },
    getUploadValidationError(file) {
      if (!file || !file.type) {
        return "Only image and video files are allowed.";
      }

      const mimeType = file.type.toLowerCase();
      if (!mimeType.startsWith("image/") && !mimeType.startsWith("video/")) {
        return "Only image and video files are allowed.";
      }

      const maxBytes = this.isVideoUpload(mimeType) ? MAX_VIDEO_UPLOAD_BYTES : MAX_IMAGE_UPLOAD_BYTES;
      if (file.size > maxBytes) {
        const mediaLabel = this.isVideoUpload(mimeType) ? "video" : "image";
        return `The selected ${mediaLabel} is too large. Maximum allowed size is ${Math.ceil(maxBytes / (1024 * 1024))} MB.`;
      }

      return null;
    },
    releasePreviewUrl(fileObject) {
      if (fileObject && fileObject.isObjectUrl && fileObject.src) {
        URL.revokeObjectURL(fileObject.src);
      }
    },
    clearCurrentEditPreviewUrl() {
      if (this.currentEditPreviewObjectUrl) {
        URL.revokeObjectURL(this.currentEditPreviewObjectUrl);
        this.currentEditPreviewObjectUrl = null;
      }
    },
    buildAccess() {
      const tokens = ["self"];

      if (this.isVisibleToParents) {
        tokens.push("parents");
      }

      if (this.isVisibleToHospital) {
        tokens.push("hospital");
      }

      if (this.isVisibleToThirdParties) {
        tokens.push("third");
      }

      return tokens.join(",");
    },
    applyAccessToForm(access) {
      const tokens = this.parseAccessTokens(access);

      this.isVisibleToSelf = true;
      this.isVisibleToParents = tokens.has("parents");
      this.isVisibleToHospital = tokens.has("hospital");
      this.isVisibleToThirdParties = tokens.has("third");
    },
    parseAccessTokens(access) {
      if (!access || !access.trim()) {
        return new Set(["parents"]);
      }

      const normalized = access.trim().toLowerCase();

      if (normalized === "pub") {
        return new Set(["parents", "hospital", "third"]);
      }

      if (normalized === "priv") {
        return new Set(["parents", "hospital"]);
      }

      const tokens = access
        .split(/[,;\s]+/)
        .map(token => token.trim().toLowerCase())
        .filter(Boolean);

      if (tokens.length === 0) {
        return new Set(["parents"]);
      }

      return new Set(tokens);
    },
    confirmChoice() {
      this.$modal.hide('create-type-modal');
      if (this.postType === "reflection") {
        this.$modal.show('create-reflection-modal');
      }
    },
    closeChoiceModal() {
      this.$modal.hide('create-type-modal');
    },
    handlePostTypeSelected(postType) {
      this.postType = postType;
      if (postType === "reflection") {
        this.$modal.show('create-reflection-modal');
      }
    },
    async createPosts(action) {
      if (this.postType === "reflection") {
        this.$modal.show('create-reflection-modal');
        return;
      }

      if (!this.validatePostForm()) {
        return;
      }

      this.loading = true;
      console.log("working")
      if (action === "add") {
        if (this.files.length > 0) {
          for (const i in this.files) {
            let isFinal = (this.files.length - 1) == i
            try {
              await this.createPost(this.files[i], isFinal);
              if (isFinal) {
                this.navigateAfterSave();
              }
            } catch (err) {
              this.loading = false;
              return;
            }
          }
        }
      }
      this.loading = false
    },

    async createPost(fileObj, isFinal) {
      let uploadedImageId = null
      const access = this.postAccess;
      const uploadAccess = this.uploadAccess;
      const formData = new FormData()
      formData.append("file", fileObj.file, fileObj.file.name)
      formData.append("access", uploadAccess)
      formData.append("mimeType", fileObj.file.type)
      formData.append("patientId", this.$store.getters.patient.id)

      try {
        const uploadResult = await neoparentUploads.uploadFile(formData);
        uploadedImageId = uploadResult.data.data.id;
      } catch (err) {
        this.error = err.response?.data?.message || "Unable to upload the selected media.";
        window.scrollTo(0, 0);
        throw err;
      }

      const data = {
        title: this.milestone ? this.$t("general.milestone.title") : this.title,
        content: isFinal ? this.content : null,
        access: access,
        isDraft: this.isDraft,
        patients: this.patients,
        uploadId: uploadedImageId,
        milestoneId: this.milestone ? this.milestone.id : null,
        dictionaryEntries: isFinal ? this.addedDictionaryEntries : null
      };

      data.isVisible = true

      try {
        await neoparentPosts.addPost(this.$store.getters.user.patient.id, data);
      } catch (err) {
        if (uploadedImageId) {
          await neoparentUploads.deleteImage(uploadedImageId).catch(() => { });
        }
        this.loading = false;
        this.error = err.response?.data?.message || "error.post.incompleteForm";
        window.scrollTo(0, 0);
        console.log(err);
        throw err;
      }
    },

    async writePost(action) {
      if (this.postType === "reflection") {
        this.$modal.show('create-reflection-modal');
        return;
      }
      if (action !== "add" && action !== "edit") return;

      if (!this.validatePostForm()) {
        return;
      }

      this.loading = true;
      const access = this.postAccess;
      const uploadAccess = this.uploadAccess;

      let uploadedImageId = null


      if (this.file) {
        const formData = new FormData()
        formData.append("file", this.file, this.file.name)
        formData.append("access", uploadAccess)
        formData.append("mimeType", this.file.type)
        formData.append("patientId", this.$store.getters.patient.id)

        try {
          const uploadResult = await neoparentUploads.uploadFile(formData);
          uploadedImageId = uploadResult.data.data.id;
        } catch (err) {
          this.loading = false;
          this.error = err.response?.data?.message || "Unable to upload the selected media.";
          window.scrollTo(0, 0);
          return;
        }
      }

      const data = {
        title: this.milestone ? this.$t("general.milestone.title") : this.title,
        content: this.content,
        access: access,
        patients: this.patients,
        uploadId: uploadedImageId,
        removeUpload: action === "edit" ? this.removeCurrentPostImage : false,
        isDraft: this.isDraft,
        milestoneId: this.milestone ? this.milestone.id : null,
        dictionaryEntries: this.addedDictionaryEntries
      };
      this.consoleLog(data);

      if (action === "add") {
        // Create new
        this.consoleLog("Creating post");
        data.isVisible = true
        neoparentPosts
          .addPost(this.$store.getters.user.patient.id, data)
          .then(result => {
            this.consoleLog(result);
            this.loading = false;
            this.navigateAfterSave();
          })
          .catch(async err => {
            if (uploadedImageId) {
              await neoparentUploads.deleteImage(uploadedImageId).catch(() => { });
            }
            this.loading = false;
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            console.log(err);
          });
      } else {
        // Edit post
        this.consoleLog("Updating post");
        data.id = this.editId;
        neoparentPosts
          .editPost(this.editId, data)
          .then(result => {
            this.consoleLog(result);
            this.loading = false;
            this.navigateAfterSave();
          })
          .catch(async err => {
            if (uploadedImageId) {
              await neoparentUploads.deleteImage(uploadedImageId).catch(() => { });
            }
            this.loading = false;
            this.error = err.response.data.message;
            window.scrollTo(0, 0);
            console.log(err);
          });
      }
    },
    async fileSelect(files) {
      if (!files) {
        console.warn("No files provided to fileSelect");
        return;
      }

      const fileArray = files[Symbol.iterator] ? Array.from(files) : [files];
      let hasAddedValidFile = false;

      for (const file of fileArray) {
        const uploadError = this.getUploadValidationError(file);
        if (uploadError) {
          this.error = uploadError;
          window.scrollTo(0, 0);
          continue;
        }

        const previewUrl = URL.createObjectURL(file);

        if (!this.postId) {
          this.files.push({
            src: previewUrl,
            file,
            isVideo: this.isVideoUpload(file.type),
            isObjectUrl: true
          });
          hasAddedValidFile = true;
        } else {
          this.clearCurrentEditPreviewUrl();
          this.currentEditPreviewObjectUrl = previewUrl;
          this.file = file;
          this.removeCurrentPostImage = false;

          if (!this.post.upload) {
            this.$set(this.post, "upload", {
              blobUri: previewUrl,
              mimeType: file.type
            });
          } else {
            this.post.upload.blobUri = previewUrl;
            this.$set(this.post.upload, "mimeType", file.type);
          }

          hasAddedValidFile = true;
        }
      }

      if (hasAddedValidFile) {
        this.error = "";
      }
    },
    typingTimer(query) {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.searchDictionary(query);
      }, 500);
    },
    async searchDictionary(query) {
      await dictionaryEntries.getAll(query).then(x => {
        this.dictionaryEntries = x.data.entries;
      })
    },
    dictionarySelectionChanged: function (e) {
      const entry = JSON.parse(e.target.getAttribute("data-value"));
      // no duplicates
      if (!this.addedDictionaryEntries.find(e => entry.id === e.id)) {
        this.addedDictionaryEntries.push(entry);
      }
    },
    deleteFile(index) {
      const fileObject = this.files[index];
      this.releasePreviewUrl(fileObject);
      this.files.splice(index, 1)
    },
    removeCurrentImage() {
      this.clearCurrentEditPreviewUrl();
      this.file = null;
      this.removeCurrentPostImage = true;
      if (this.post) {
        this.post.upload = null;
        this.post.uploadId = null;
      }
    },
    validatePostForm() {
      const title = (this.milestone ? this.$t("general.milestone.title") : this.title || "").trim();
      const content = (this.content || "").trim();

      if (!title || !content) {
        this.error = this.$t("error.post.incompleteForm");
        window.scrollTo(0, 0);
        return false;
      }

      this.error = "";
      return true;
    },
    navigateAfterSave() {
      if (this.$store.getters.user.role === "p") {
        window.location.href = "/";
      } else if (this.$store.getters.nurse) {
        window.location.href = `/dashboard/nurse/${this.$store.getters.nurse.id}/patient/${this.$store.getters.user.patient.id}`;
      } else {
        window.location.href = `/dashboard/nurse/${this.$store.getters.user.id}/patient/${this.$store.getters.user.patient.id}`;
      }
    }
  }
};
</script>

<style scoped lang="scss">
p {
  margin: 1rem 0 0;
  text-align: left;
}

#img-preview {
  max-height: 300px;
  object-fit: contain;
  width: 100%;
}

.upload-preview-video {
  width: 100%;
  max-height: 300px;
  object-fit: contain;
  background: #000;
}

.space {
  content: " ";
  margin-bottom: 20px;
}

.checkbox-container-create-post {
  position: relative;
  padding-left: 36px;
  user-select: none;

  .checkmark {
    border: 1px solid #00a9b3;
    border-radius: 50%;
    position: absolute;
    top: 0;
    left: 0;
    height: 20px;
    width: 20px;
    background-color: #fff;
  }

  input:checked~.checkmark {
    background-color: #fff;
    border: 1px solid #e05484;
  }

  input:checked~.checkmark:after {
    display: block;
  }

  .checkmark:after {
    content: '';
    position: absolute;
    display: none;
    left: 7px;
    top: -2px;
    width: 7px;
    height: 13px;
    border: solid #e05484;
    border-width: 0 1px 1px 0;
    transform: rotate(45deg);
  }

  input {
    position: absolute;
    opacity: 0;
    height: 0;
    width: 0;
  }
}
</style>
